// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_Village_Person_Board_container__2z2B_"};